import {
	Intro as Chapter01Intro,
	Summary as Chapter01Summary
} from './01'

import Chapter01Aspect01 from './01/01/Aspect01'
import Chapter01Aspect02 from './01/02/Aspect02'
import Chapter01Aspect03 from './01/03/Aspect03'
import Chapter01Aspect04 from './01/04/Aspect04'

import {
	Intro as Chapter02Intro,
	Summary as Chapter02Summary
} from './02'

import Chapter02Aspect01 from './02/01/Aspect01'
import Chapter02Aspect02 from './02/02/Aspect02'
import Chapter02Aspect03 from './02/03/Aspect03'
import Chapter02Aspect04 from './02/04/Aspect04'

import {
	Intro as Chapter03Intro,
	Summary as Chapter03Summary
} from './03'

import Chapter03Aspect01 from './03/01/Aspect01'
import Chapter03Aspect02 from './03/02/Aspect02'
import Chapter03Aspect03 from './03/03/Aspect03'

import {
	Intro as Chapter04Intro,
	Summary as Chapter04Summary
} from './04'

import Chapter04Aspect01 from './04/01/Aspect01'
import Chapter04Aspect02 from './04/02/Aspect02'
import Chapter04Aspect03 from './04/03/Aspect03'

import {
	Intro as Chapter05Intro,
	Summary as Chapter05Summary
} from './05'

import Chapter05Aspect01 from './05/01/Aspect01'
import Chapter05Aspect02 from './05/02/Aspect02'
import Chapter05Aspect03 from './05/03/Aspect03'
import Chapter05Aspect04 from './05/04/Aspect04'

export const Chapters = {
	Chapter01: {
		Intro: Chapter01Intro,
		Aspect01: Chapter01Aspect01,
		Aspect02: Chapter01Aspect02,
		Aspect03: Chapter01Aspect03,
		Aspect04: Chapter01Aspect04,
		Summary: Chapter01Summary,
	},
	Chapter02: {
		Intro: Chapter02Intro,
		Aspect01: Chapter02Aspect01,
		Aspect02: Chapter02Aspect02,
		Aspect03: Chapter02Aspect03,
		Aspect04: Chapter02Aspect04,
		Summary: Chapter02Summary,
	},
	Chapter03: {
		Intro: Chapter03Intro,
		Aspect01: Chapter03Aspect01,
		Aspect02: Chapter03Aspect02,
		Aspect03: Chapter03Aspect03,
		Summary: Chapter03Summary,
	},
	Chapter04: {
		Intro: Chapter04Intro,
		Aspect01: Chapter04Aspect01,
		Aspect02: Chapter04Aspect02,
		Aspect03: Chapter04Aspect03,
		Summary: Chapter04Summary,
	},
	Chapter05: {
		Intro: Chapter05Intro,
		Aspect01: Chapter05Aspect01,
		Aspect02: Chapter05Aspect02,
		Aspect03: Chapter05Aspect03,
		Aspect04: Chapter05Aspect04,
		Summary: Chapter05Summary,
	},
}



// WEBPACK FOOTER //
// ./src/content/chapters/index.js